import script from "./rate-widget-ly.vue?vue&type=script&setup=true&lang=js"
export * from "./rate-widget-ly.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__